import React from "react"

const BigGreenCheck = ({ ...props }) => {
  return (
    <svg
      className="ism-checkmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 54 54"
      {...props}
    >
      <circle
        className="ism-checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className="ism-checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  )
}

export default BigGreenCheck
